module.exports = __webpack_public_path__ + "img/drop-two.b16f5c66.png";